interface DevCardObject {
  /**
   * @description title of the developer skill
   */
  title: string,
  /**
   * @description detail of the work and reponsibilites
   */
  description: string,
  /**
   * @description image to show on card
   */
  image_url: string;
  /**
   * @description technologies used and implemented and tools used for them
   */
  techonologiesAndTools?: string[];
};

/** 
 *
 * @class
 * @implements {DevCardObject}
 */
class DevCardClass implements DevCardObject{
  title: string;
  description: string;
  image_url: string;
  techonologiesAndTools?: string[];


  /**
   * 
   * @param {object} DevCardObject
   */
  constructor({title, description, image_url, techonologiesAndTools} : DevCardObject) {
    this.title = title;
    this.description = description;
    this.image_url = image_url
    this.techonologiesAndTools = techonologiesAndTools;
  }
};

export {DevCardClass}
export type { DevCardObject };
